import { render, staticRenderFns } from "./dispute.vue?vue&type=template&id=39eee6c2&scoped=true&"
import script from "./dispute.vue?vue&type=script&lang=js&"
export * from "./dispute.vue?vue&type=script&lang=js&"
import style0 from "./dispute.vue?vue&type=style&index=0&id=39eee6c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39eee6c2",
  null
  
)

export default component.exports